import { Component, Prop, Model, Vue } from 'nuxt-property-decorator';

@Component
export default class SelectBar extends Vue {
  @Model('change')
  modelValue!: any[];

  @Prop({ type: Array, default: [] })
  list!: [{
    label: string;
    value: any;
    color: string;
    icon: any;
  }];

  selected: any[] = [...this.modelValue];

  toggle(e: Event, item: any): void {
    const itemElement = e && e.target && (e.target as HTMLInputElement);

    if (itemElement && itemElement.checked) {
      this.selected.push(item.value);
    } else {
      this.selected.splice(this.selected.indexOf(item.value), 1);
    }
    this.$emit('change', this.selected);
  }
}
